export default {
  "app": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Portfolio by Likhacheva Mariya"])}
  },
  "nav": {
    "home": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Home"])},
    "about": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["About me"])},
    "project": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["My project"])},
    "contact": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contact me"])}
  },
  "home": {
    "hello": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hello!"])},
    "welcome": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["I'm Masha, and I'm a web-developer"])},
    "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View projects"])}
  },
  "about": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["About me"])},
    "text-one": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Currently, the Internet is the most demanded way of promoting and advertising a company. The company's website is a presentation of its presence on the web for customers, a business card that cannot be lost."])},
    "text-two": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["I create small-scale websites consisting of one or multiple pages, as well as catalog websites with information about company products. I ensure that these websites are mobile-friendly, and I also optimize them for search engines like Yandex and Google. I am always available and focused on delivering results. I pay attention to every detail in my work."])},
    "text-three": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["I have programming skills such as HTML/CSS, Bootstrap, GSAP, Figma, JavaScript, React, Redux, GitHub and I'm currently finishing learning Node.JS and have some experience in a digital studio where I have mastered Vue.js, Vuex, Nuxt, Quasar, Vuetify."])}
  },
  "project": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["My projects"])},
    "btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View project"])}
  },
  "contact": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contact me"])},
    "phone": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You can call me at"])},
    "messenger": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Check out my GitHub profile or contact me via messenger:"])}
  },
  "error": {
    "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oops... Nothing here..."])},
    "btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back to Home"])}
  }
}